export const actionTypes = {
    SET_CURRENT_ACTIVE_POPOVER: 'SET_CURRENT_ACTIVE_POPOVER',
    CLOSE_CURRENT_ACTIVE_POPOVER: 'CLOSE_CURRENT_ACTIVE_POPOVER',
};

export const setActivePopoverWithTypeAndFeed = (modalType, feed) => ({
    type: actionTypes.SET_CURRENT_ACTIVE_POPOVER,
    activePopoverType: modalType,
    activePopoverFeed: feed,
});

export const closeCurrentPopover = () => ({
    type: actionTypes.CLOSE_CURRENT_ACTIVE_POPOVER,
})



// WEBPACK FOOTER //
// /src/js/common/bookmakersListPopover/bookmakersButtonsPopovers.actions.js